import React from 'react';
import propTypes from 'prop-types';
import { concatClassName } from '@dateam/ark-react';
import styles from './Page.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const PageContent: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <div className={concatClassName(styles['content'], className)}>
        {children}
    </div>
);

PageContent.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

PageContent.defaultProps = {
    className: undefined,
    children: undefined
};

export default PageContent;
